import { render, staticRenderFns } from "./wrapper-simple-component.vue?vue&type=template&id=6b305b55&scoped=true&"
import script from "./wrapper-simple-component.vue?vue&type=script&lang=ts&"
export * from "./wrapper-simple-component.vue?vue&type=script&lang=ts&"
import style0 from "./wrapper-simple-component.vue?vue&type=style&index=0&id=6b305b55&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b305b55",
  null
  
)

export default component.exports